import { useEffect, useState } from "react";
import {
  ActivityIndicator,
  ScrollView,
  StyleSheet,
  Text,
  View,
} from "react-native";
import { ButtonCP } from "./components/ButtonCP";
import { EditText } from "./components/EditText";
import { executeTrx } from "./repository/transaction";

export const VirtualTerminal = ({ token, type }) => {
  const [details, setDetails] = useState({
    name: "",
    billingAddress: "",
    city: "",
    state: "",
    zip: "12345",
    email: "",
    phoneNumber: "8106883711",
    amount: "",
    expirationDate: "",
    month: "01",
    year: "2023",
    cardConnectToken: "4111111111111111",
    cvv: "123",
  });

  const [wait, setWait] = useState(true);

  const setName = (value) => {
    setDetails((prev) => ({ ...prev, name: value }));
  };

  const setBillingAddress = (value) => {
    setDetails((prev) => ({ ...prev, billingAddress: value }));
  };

  const setCity = (value) => {
    setDetails((prev) => ({ ...prev, city: value }));
  };

  const setState = (value) => {
    setDetails((prev) => ({ ...prev, state: value }));
  };

  const setZip = (value) => {
    setDetails((prev) => ({ ...prev, zip: value }));
  };

  const setEmail = (value) => {
    setDetails((prev) => ({ ...prev, email: value }));
  };

  const setPhoneNumber = (value) => {
    if (/^\d+$/.test(value.toString()))
      setDetails((prev) => ({ ...prev, phoneNumber: value }));
  };

  const setCVV = (value) => {
    console.log(/^\d+$/.test(value.toString()));
    if (/^\d+$/.test(value.toString()))
      setDetails((prev) => ({ ...prev, cvv: value }));
  };

  const setAmount = (value) => {
    if (/^\d+$/.test(value.toString()))
      setDetails((prev) => ({ ...prev, amount: value }));
  };

  const setMonth = (value) => {
    if (/^\d+$/.test(value.toString()))
      setDetails((prev) => ({ ...prev, month: value }));
  };

  const setYear = (value) => {
    if (/^\d+$/.test(value.toString()))
      setDetails((prev) => ({ ...prev, year: value }));
  };

  const cardConnectCallBack = (value) => {
    if (/^\d+$/.test(value.toString()))
      setDetails((prev) => ({ ...prev, cardConnectToken: value }));
  };

  const process = async () => {
    setWait(true);
    const response = await executeTrx(token, details);
    console.log(JSON.parse(response));
    if (JSON.parse(response).contextResponse.statusCode === "SUCCESS")
      alert("Payment Processed Successfully ");
    else alert(response);
    setWait(false);
  };

  useEffect(() => {
    if (type === "FIS") setWait(false);
  }, []);

  return (
    <ScrollView style={styles.container}>
      <View style={styles.subContaier}>
        <Text style={styles.title}>All fields are required</Text>

        <EditText
          placeholder="Name on card"
          keyboardType="default"
          style={styles.margin}
          onChangeText={setName}
        />
        <EditText
          placeholder="Billing Address"
          keyboardType="default"
          style={styles.margin}
          onChangeText={setBillingAddress}
          value={details.billingAddress}
        />
        <EditText
          placeholder="City"
          keyboardType="default"
          style={styles.margin}
          onChangeText={setCity}
          value={details.city}
        />
        <EditText
          placeholder="State"
          keyboardType="default"
          style={styles.margin}
          onChangeText={setState}
          value={details.state}
        />
        <EditText
          placeholder="Zip / Postal Code"
          keyboardType="default"
          style={styles.margin}
          onChangeText={setZip}
          value={details.zip}
        />
        <EditText
          placeholder="Email Address"
          keyboardType="email-address"
          style={styles.margin}
          onChangeText={setEmail}
          value={details.email}
        />
        <EditText
          placeholder="Phone Number"
          keyboardType="numeric"
          style={styles.margin}
          onChangeText={setPhoneNumber}
          value={details.phoneNumber}
        />
        <EditText
          placeholder="Card Number"
          keyboardType="numeric"
          style={styles.margin}
          maxLength={16}
          onChangeText={cardConnectCallBack}
          value={details.cardConnectToken}
        />
        <EditText
          maxLength={3}
          placeholder="CVV"
          keyboardType="numeric"
          style={styles.margin}
          onChangeText={setCVV}
          value={details.cvv}
        />
        <View
          style={{
            flexDirection: "row",
            marginHorizontal: 20,
            marginTop: 8,
          }}
        >
          <EditText
            style={{ width: 146, minWidth: 146, marginEnd: 4 }}
            maxLength={2}
            keyboardType="numeric"
            onChangeText={setMonth}
            value={details.month}
          />
          <EditText
            style={{ width: 146, minWidth: 146, marginStart: 4 }}
            maxLength={4}
            keyboardType="numeric"
            onChangeText={setYear}
            value={details.year}
          />
        </View>
        <EditText
          placeholder="Amount USD"
          keyboardType="numeric"
          style={styles.margin}
          onChangeText={setAmount}
          value={details.amount}
        />
        {wait ? (
          <ActivityIndicator size={"large"} style={styles.buttonMargin} />
        ) : (
          <ButtonCP
            text="Process Transaction"
            style={styles.buttonMargin}
            onPress={process}
          />
        )}
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: 18,
    color: "red",
  },
  margin: {
    marginTop: 8,
  },
  buttonMargin: {
    margin: 16,
    marginTop: 32,
  },
  label: {
    marginTop: 16,
    textAlign: "left",
    marginStart: 20,
    marginBottom: 4,
    fontSize: 16,
    alignSelf: "flex-start",
  },
  subContaier: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: 50,
  },
  container: {
    flex: 1,
    width: "100%",
  },
});
